import { PreferredCategories, Rating } from './portfolio-preferences.model';

export interface RatingLabel {
    value: PreferredCategories;
    title: string,
    label: string;
    subLabel: string;
    color: string;
}

export class RatingLabels extends Array<RatingLabel> {
    private constructor(ratingLabels: RatingLabel[]) {
        super(...ratingLabels);
    }

    public static defaults(): RatingLabels {
        const defaultRatingLabels: RatingLabel[] = [
            {
                value: { ratingList: [Rating.A1, Rating.A2, Rating.A3, Rating.A4, Rating.A5, Rating.A6] },
                title: 'Low Risk',
                label: 'A1-A6',
                subLabel: '10.99% to 15.99%',
                color: '#97b81e'
            }, {
                value: { ratingList: [Rating.B1, Rating.B2, Rating.B3, Rating.B4, Rating.B5, Rating.B6] },
                title: 'Medium Risk',
                label: 'B1-B6',
                subLabel: '16.99% to 21.99%',
                color: '#ffc80b'
            }, {
                value: { ratingList: [Rating.C1, Rating.C2, Rating.C3, Rating.C4, Rating.C5, Rating.C6] },
                title: 'High Risk',
                label: 'C1-C6',
                subLabel: '22.99% to 27.99%',
                color: '#f65a41'
            }
        ];
        return new RatingLabels(defaultRatingLabels);
    }
}
